import { validateVal } from "./numberMethods";
export var summarizeType;
(function (summarizeType) {
    summarizeType["K"] = "K";
    summarizeType["LAKHS"] = "L";
    summarizeType["CR"] = "Cr";
})(summarizeType || (summarizeType = {}));
export function summarizeWithType(val, type, typeView) {
    if (typeView === void 0) { typeView = true; }
    if (!validateVal(val === null || val === void 0 ? void 0 : val.valueOf())) {
        var negative = Number(val) < 0;
        val = Math.abs(Number(val));
        if (type === summarizeType.K) {
            var result = Math.round(Number(val) / 10) / 100;
            val = typeView ? result + "K" : result;
        }
        else if (type === summarizeType.LAKHS) {
            var result = Math.round(Number(val) / 1000) / 100;
            val = typeView ? result + "L" : result;
        }
        else if (type === summarizeType.CR) {
            var result = Math.round(Number(val) / 100000) / 100;
            val = typeView ? result + "Cr" : result;
        }
        return negative ? "-" + val : val;
    }
    else {
        return "--";
    }
}
